var _defs, _path, _polygon, _polygon2, _polygon3, _rect, _polygon4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEvand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "10 58 125 25",
    className: "jsx-1823416988 evand-logo-full",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    className: "jsx-1823416988"
  }, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill: #132a3e;} .cls-2{fill: #0095db;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    className: "jsx-1823416988",
    id: titleId
  }, "\u0627\u06CC\u0648\u0646\u062F") : title ? /*#__PURE__*/React.createElement("title", {
    className: "jsx-1823416988",
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.62,80.56H111.68V61.17h10.93a5,5,0,0,1,5,5v9.45A5,5,0,0,1,122.62,80.56Zm-6.91-2.12H122a2.85,2.85,0,0,0,2.85-2.85V66.14A2.85,2.85,0,0,0,122,63.29h-6.28V78.44Z",
    className: "jsx-1823416988 cls-1"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "55.64 80.56 50.84 80.56 43.01 61.2 47.66 61.17 54.21 77.27 60.76 61.17 63.47 61.2 55.64 80.56",
    className: "jsx-1823416988 cls-1"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "76.05 61.17 71.3 61.17 63.47 80.54 67.64 80.56 74.19 64.46 80.73 80.56 83.88 80.54 76.05 61.17",
    className: "jsx-1823416988 cls-1"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "38.41 80.56 24.47 80.56 24.47 79.5 24.47 62.23 24.47 61.17 38.41 61.17 38.41 63.3 28.5 63.3 28.5 78.44 38.41 78.44 38.41 80.56",
    className: "jsx-1823416988 cls-1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.94,
    y: 68.98,
    width: 19.55,
    height: 3.77,
    className: "jsx-1823416988 cls-2"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "107.09 80.54 107.09 61.17 104 61.17 104 76.24 92.77 61.19 88.48 61.17 88.48 80.56 92.51 80.56 92.51 65.31 103.54 80.54 107.09 80.54",
    className: "jsx-1823416988 cls-1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvand);
export default __webpack_public_path__ + "static/media/evand.0684567856fbc24c75d783ba12ddc825.svg";
export { ForwardRef as ReactComponent };